<div
  *ngIf="active"
  [class]="'loading-indicator loading-indicator--' + position + ' loading-indicator--' + delay"
>
  <mat-spinner
    class="loading-indicator__spinner"
    [diameter]="diameter"
  ></mat-spinner>
</div>
